import { FormField, FormItem, FormControl } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { PillSelector } from "./PillSelector";

/**
 * A subject row card used in progress report forms.
 *
 * Props:
 *   label         - Subject display name (e.g. "Language")
 *   planField     - RHF field name for the plan pill
 *   resultField   - RHF field name for the result pill
 *   plans         - Array<{ value, label }> for the plan PillSelector
 *   resultOptions - Array<{ value, label }> for the result PillSelector
 *   resultColorMap - colorMap passed to result PillSelector
 *   nameField     - optional RHF field name for a subject-name text input
 *   control       - react-hook-form control
 */
export function SubjectRow({ label, planField, resultField, plans, resultOptions, resultColorMap, nameField, control }) {
  return (
    <div className="rounded-xl border border-border bg-card p-4 space-y-3">
      <p className="font-semibold text-foreground">{label}</p>
      {nameField && (
        <FormField
          control={control}
          name={nameField}
          render={({ field }) => (
            <FormItem>
              <FormControl>
                <Input placeholder={`${label} name`} {...field} />
              </FormControl>
            </FormItem>
          )}
        />
      )}
      <div className="space-y-1">
        <p className="text-xs text-muted-foreground font-medium uppercase tracking-wide">Plan</p>
        <FormField
          control={control}
          name={planField}
          render={({ field }) => (
            <FormItem>
              <FormControl>
                <PillSelector value={field.value} onChange={field.onChange} options={plans} colorMap={{}} />
              </FormControl>
            </FormItem>
          )}
        />
      </div>
      <div className="space-y-1">
        <p className="text-xs text-muted-foreground font-medium uppercase tracking-wide">Result</p>
        <FormField
          control={control}
          name={resultField}
          render={({ field }) => (
            <FormItem>
              <FormControl>
                <PillSelector value={field.value} onChange={field.onChange} options={resultOptions} colorMap={resultColorMap} />
              </FormControl>
            </FormItem>
          )}
        />
      </div>
    </div>
  );
}
